// extracted by mini-css-extract-plugin
module.exports = {"root":"Link-root-dc6c27cf28d1dc5f01a91cb08f0bbbc2"};